var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0731CE4F-2767-4BE4-9983-A784D4538129") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-236.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome",
    transform: "translate(236.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,12 C1.25,6.07000017 6.07000017,1.25 12,1.25 C17.9299998,1.25 22.75,6.07000017 22.75,12 C22.75,17.9299998 17.9299998,22.75 12,22.75 C6.07000017,22.75 1.25,17.9299998 1.25,12 Z M2.75,12 C2.75,17.0999999 6.9000001,21.25 12,21.25 C17.0999999,21.25 21.25,17.0999999 21.25,12 C21.25,6.9000001 17.0999999,2.75 12,2.75 C6.9000001,2.75 2.75,6.9000001 2.75,12 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25,12 C7.25,9.38000011 9.38000011,7.25 12,7.25 C14.6199999,7.25 16.75,9.38000011 16.75,12 C16.75,14.6199999 14.6199999,16.75 12,16.75 C9.38000011,16.75 7.25,14.6199999 7.25,12 Z M8.75,12 C8.75,13.79 10.21,15.25 12,15.25 C13.79,15.25 15.25,13.79 15.25,12 C15.25,10.21 13.79,8.75 12,8.75 C10.21,8.75 8.75,10.21 8.75,12 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0097847,8.72994101 C18.0697846,8.08994102 15.0997841,8.08994102 12.159784,8.72994101 C11.749784,8.81994101 11.3597846,8.55994132 11.2697846,8.15994132 C11.1797846,7.74994132 11.4397843,7.35994139 11.8397843,7.26994139 C14.9897844,6.57994139 18.1797843,6.57994139 21.3297844,7.26994139 C21.7297844,7.35994139 21.9897841,7.75994131 21.8997841,8.15994132 C21.8297841,8.50994131 21.5197845,8.74994147 21.1697845,8.74994147 C21.1197845,8.74994147 21.0597847,8.73994101 21.0097847,8.72994101 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96976566,14.4900684 C5.88976574,12.1000683 4.30976558,9.37006807 3.25976562,6.37006807 L3.94976568,6.06006813 L4.65976548,5.82006836 L4.67976546,5.8800683 C5.65976548,8.69006824 7.14976501,11.2600684 9.10976505,13.5100684 C9.37976506,13.8200684 9.34976536,14.3000683 9.03976536,14.5700684 C8.88976535,14.6900684 8.70976536,14.7500687 8.53976536,14.7500687 C8.32976536,14.7500687 8.11976567,14.6600684 7.96976566,14.4900684 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3798409,22.4999695 C10.0698409,22.2199695 10.0498407,21.74997 10.3298407,21.43997 C12.3298407,19.23997 13.8098403,16.6899686 14.7298403,13.8599687 C14.8598403,13.4699687 15.2998403,13.2099692 15.6898403,13.3399692 C16.0798403,13.4699692 16.3098413,13.8499689 16.1898413,14.2399688 C15.1798413,17.3599687 13.5898408,20.0999687 11.4498407,22.4599686 C11.2898407,22.6099686 11.079841,22.68997 10.879841,22.68997 C10.699841,22.68997 10.5198409,22.6299695 10.3798409,22.4999695 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineChrome);
export default __webpack_public_path__ + "static/media/vuesax-outline-chrome.7623ca36f2c95508e5d174b19eacf3b1.svg";
export { ForwardRef as ReactComponent };